import {Component, OnInit, signal} from '@angular/core';
import {BaseService} from "../services/base.service";
import {SideNav} from "../repository/entity/base.entity";
import {Observable, switchMap, tap} from "rxjs";
import {LoginResponse} from "../../auth/repository/entity/auth.entity";
import {AuthService} from "../../auth/service/auth.service";
import {BranchService} from "../../branch/branch.service";

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss'
})
export class BaseComponent implements OnInit {
  sideNav: SideNav[] = [];
  supportingText = signal("");
  activeCompanyCode$: Observable<string>;
  userLogin$: Observable<LoginResponse>;

  constructor(private baseService: BaseService, private authService: AuthService, private branchService: BranchService) {
  }

  ngOnInit() {
    this.userLogin$ = this.authService.getUserLogin().pipe(
      tap(u => this.baseService.checkCompanyCode(u.companies))
    );
    this.activeCompanyCode$ = this.branchService.fetchAllBranch().pipe(
      switchMap(() => this.baseService.getCompanyCode())
    );

    this.supportingText = this.baseService.getSupportingText();
    this.sideNav = this.baseService.fetchSideNav();
  }

  onChangeCompany(companyCode: string) {
    this.baseService.activeCompanyCode = companyCode;
  }
}
